import { useI18n } from "../../../../hooks/i18n/i18n";

type Output = {
  text: string;
};
type UseThis = () => Output;

export const useThis: UseThis = () => {
  const { t } = useI18n();

  return {
    text: t("search.noResult"),
  };
};
